import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderPaid } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type PayOrderProps = {
  formData: IOrderPaid;
} & RequestsProps;

export type UsePayOrderReturn = {
  create: (props: PayOrderProps) => Promise<void>;
} & UseLoadingReturn;

const usePayOrder = (): UsePayOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderPaid>({
    operation: (formData) => orderStatusService.pay(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default usePayOrder;
